import styled from "styled-components";
import {StyledModal} from "../../common/shared/modal.styled";


export const UploadFailedModalStyled = styled(StyledModal)`
  .modal-header {
    display: flex;
    padding: 15px 20px;
    border: none;
    justify-content: flex-end !important; 
    button {
      flex: 0 0 16px;
      width: 16px;
      height: 16px;
      border: none;
      line-height: 0;
      background-color: transparent;
      cursor: pointer;
      padding: 0;
      color: var(--bllink-gray);
    }
  }
  .modal-body {
    h1 {
      margin-top: 0;
    }
    button {
      margin-top: 32px;
    }
  }
`;
